import type { ActivityContext } from './SignupJourneyContext'

export const DEFAULT_ACTIVITY_VALUES: ActivityContext = {
  activity: undefined,
  otherActivityComment: undefined,
  socialUrls: [''],
  targetCustomer: undefined,
  phoneNumber: '',
  culturalDomains: undefined,
}
